import PubSub from "underpub-js";

var FloorplanListing = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FloorplanListing',
	};

	$.extend(true, this.options, options);

};

FloorplanListing.prototype.init = function() {

	var self = this;

};

export default FloorplanListing;
